import { useMutation } from "@apollo/react-hooks";
import { SocketContext } from "@context/socket";
import { JOIN_COINFLIP_GAME } from "@graphql/Mutations";
import useReduxState from "@hooks/useReduxState";
import { toastSuccessMessage, toastErrorMessage } from "@utils/utils";
import { useContext, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

export function CoinFlipRedirect(): JSX.Element {
  const { gameUid } = useParams();
  const [user] = useReduxState((state) => state.userData);
  const socket = useContext(SocketContext);
  const navigate = useNavigate();
  const [joinCoinflipGame] = useMutation(JOIN_COINFLIP_GAME, {
    onCompleted: ({ joinCoinflipGame }) => {
      socket.emit("Join-Coinflip", joinCoinflipGame);
      toastSuccessMessage("Succesfully joined game");
      navigate("../", { replace: true });
    },
    onError: (e) => {
      toastErrorMessage(e.message);
      navigate("../", { replace: true });
    },
  });

  useEffect(() => {
    socket.emit("coinflip");
    if (user.uid !== "") {
      (async () => {
        await joinCoinflipGame({
          variables: {
            gameUid: gameUid,
            userId: user.id,
          },
        });
      })();
    }
  }, [user]);
  return <></>;
}
